<div class="app-titulo-pagina">
  <span>Novo Pagamento</span>
</div>

<div *ngIf="mainService.pagamentoService.processando" class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<div class="container" *ngIf="!mainService.pagamentoService.processando">

  <form (submit)="mainService.pagamentoService.validate()" class="col-xs-12 col-md-12" ngNativeValidate>
    <div class="app-panel">
      <div class="panel-body">
        <div class="well col-xs-12 col-md-8 col-md-offset-2  col-lg-8 col-lg-offset-2">
          <h4>Escolha o tipo de pagamento desejado</h4>
          <div class="form-group">
            <label class="app-radio-pagamento">
              <input type="radio" name="tipoPagamento" [(ngModel)]="mainService.pagamentoService.pagamento.tipo"
                value="boleto" id="inputBoleto" (click)="mainService.pagamentoService.pagamento.linhaDigitavel = ''"
                class="app-nowrap">
              Boleto de cobrança
            </label>
            <label>
              <input type="radio" name="tipoPagamento" [(ngModel)]="mainService.pagamentoService.pagamento.tipo"
                value="conta_consumo" id="inputContaConsumo"
                (click)="mainService.pagamentoService.pagamento.linhaDigitavel = ''" class="app-nowrap">
              Conta de consumo
            </label>
            <input id="codigo-barras" type="text" name="linhaDigitavel" class="form-control" id="codigo-barras-boleto"
              [(ngModel)]="mainService.pagamentoService.pagamento.linhaDigitavel"
              placeholder="Ex: 00000.00000 00000.000000 00000.000000 0 00000000000000"
              *ngIf="mainService.pagamentoService.pagamento.tipo === 'boleto'" uiBoleto uiEnter="codigo-barras-boleto">
            <input type="text" name="linhaDigitavel" [(ngModel)]="mainService.pagamentoService.pagamento.linhaDigitavel"
              class="form-control" id="codigo-barras-consumo"
              placeholder="Ex: 00000000000 0 00000000000 0 00000000000 0 00000000000 0"
              *ngIf="mainService.pagamentoService.pagamento.tipo === 'conta_consumo'" uiTributo
              uiEnter="codigo-barras-consumo">
          </div>
        </div>
        <div class="col-xs-12 text-left">
          <div class="alert alert-warning" role="alert">
            <br>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true">
              </i> Horário limite para pagamento <strong>17h00</strong>,
              pagamentos realizados após este horário serão pagos somente no próximo dia útil
              (até a data de vencimento).</p>
            <br>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              Não enviamos comprovantes de pagamentos por email.
              O mesmo estará disponível para impressão após a compensação através da opção
              <strong>extrato</strong>.
            </p>
            <br>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              Não serão aceitos pagamentos com <strong>juros</strong>.
            </p>
            <br>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              São aceitos pagamentos de boletos com <strong>desconto</strong>.
            </p>
            <br>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              São aceitos pagamentos de <strong>conta de consumo, boletos, IPVA, DARF e multas de trânsito</strong>, .
            </p>
            <br>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              <strong>IPVA, DARF e multas de trânsito</strong>, selecione opção conta de consumo.
            </p>
            <br>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Para pagamento é obrigatório a informação
              do
              documento <strong>(CPF ou CNPJ)</strong> do beneficiário, ou seja, da pessoa física ou jurídica que emitiu
              e/ou receberá o
              valor do pagamento. Por favor, <strong>valide CPF/CNPJ,</strong> antes de efetuar o pagamento
            </p>
            <br>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              <strong>Taxa de Serviço: 0 pontos.</strong>
            </p>
          </div>
          <div class="col-xs-12 text-center">
            <a (click)="mainService.loginService.changeRoute('/pagamentos')" id="btn-voltar" class="btn btn-danger-v2">
              Voltar
            </a>
            <button id="validar-pagamento" type="submit" class="btn btn-success-v2">
              Validar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/pagamento/novo-pagamento/novo-pagamento.component.html